
import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Eye } from "lucide-react";
import { format } from "date-fns";
import CountryFlag from "@/components/country/CountryFlag";

interface DocumentCardProps {
  document: any;
  onViewDocument: (document: any) => void;
}

export function DocumentCard({ document, onViewDocument }: DocumentCardProps) {
  return (
    <Card key={document.id} className="overflow-hidden">
      <div className="p-4 flex flex-col md:flex-row justify-between">
        <div className="mb-3 md:mb-0">
          <div className="flex items-center gap-2 mb-1">
            <CountryFlag
              countryCode={
                document.id_document_types?.country_code ||
                document.verification_country
              }
              className="h-4 w-5"
            />
            <span className="font-medium">
              {document.id_document_types?.document_name}
            </span>
            <Badge
              variant={
                document.verification_status === "verified"
                  ? "success"
                  : document.verification_status === "rejected"
                  ? "destructive"
                  : "outline"
              }
              className="ml-2"
            >
              {document.verification_status.charAt(0).toUpperCase() +
                document.verification_status.slice(1)}
            </Badge>
            {document.primary_document && (
              <Badge variant="secondary">Primary</Badge>
            )}
          </div>
          <div className="text-sm text-muted-foreground mt-1">
            <p>
              Document #: {document.document_number || "Not provided"}
            </p>
            <div className="flex gap-4 flex-wrap">
              {document.issue_date && (
                <span>
                  Issued:{" "}
                  {format(new Date(document.issue_date), "MMM d, yyyy")}
                </span>
              )}
              {document.expiry_date && (
                <span>
                  Expires:{" "}
                  {format(new Date(document.expiry_date), "MMM d, yyyy")}
                </span>
              )}
            </div>
            <p className="mt-1">
              Purpose:{" "}
              {document.verification_purpose === "primary"
                ? "Primary ID"
                : document.verification_purpose === "expatriate"
                ? "Expatriate Document"
                : document.verification_purpose === "passport"
                ? "Passport"
                : "Verification"}
            </p>
          </div>
        </div>
        <div className="flex items-center">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onViewDocument(document)}
            className="flex items-center gap-1"
          >
            <Eye className="h-4 w-4 mr-1" />
            View Document
          </Button>
        </div>
      </div>
    </Card>
  );
}
